function selectedCategory() {

    const selectedCategory = document.querySelector('#ticket_field_idCategory *[data-id]')

    if( selectedCategory ){
        return [
            {
                fieldName: 'idCategory',
                type: "value",
                value: selectedCategory.getAttribute('data-id')
            }
        ]
    }

    return [
        {
            fieldName: 'id',
            type: "value",
            value: 1
        }
    ]
}
export const customFilters = {
    selectedCategory: selectedCategory
};